
import store from "@/store"
import { getCookie } from '@/utils/support.js';

let userId, crmUser_id = null
let websock = null
let url = null

export function initWebSocket() {

  crmUser_id = getCookie("nibdUser_id")
  userId = `crm_${crmUser_id}`

  if (typeof WebSocket === "undefined") return alert("您的浏览器不支持WebSocket")
  url = window.location.hostname == 'crm.nibd.net' ? "wss://data.nibd.net/wss" : "wss://datatest.nibd.net/wss"

  // 初始化socket方法
  websock = new WebSocket(url);

  // 连接成功的处理
  websock.onopen = function () {
    console.log('WebSocket连接已打开！')
    if (websock.readyState == 1) {
      websock.send(userId);
    }
  };

  // 接收数据之后的处理
  websock.onmessage = function (res) {
    heartCheck.reset().start();
    /**将消息交给action处理*/
    if (res.data !== '0') {
      store.dispatch('notification/notificationHandle', res.data)
    }
  };

  // 报错的处理
  websock.onerror = function () {
    console.log('WebSocket连接失败，请检查！')
  };

  // 关闭连接的处理
  websock.onclose = function (res) {
    console.log('WebSocket 已关闭！', res)
  };
}

// 关闭
export function websockClose() {
  console.log('关闭连接!');
  websock.close()
}

//发送
export function websockSend() {
  const data = { area: 26 }
  const json = JSON.stringify(data);
  websock.send('["onMessage",' + json + ']');
}

//心跳检测
const heartCheck = {
  timeout: 1000 * 20,
  timeoutObj: null,
  serverTimeoutObj: null,
  reset: function () {
    clearTimeout(this.timeoutObj);
    clearTimeout(this.serverTimeoutObj);
    return this;
  },
  start: function () {
    const self = this;
    this.timeoutObj = setTimeout(function () {
      //这里发送一个心跳，后端收到后，返回一个心跳消息，
      //onmessage拿到返回的心跳就说明连接正常
      websock.send(userId);
      console.log('userId', userId)
      self.serverTimeoutObj = setTimeout(function () {//如果超过一定时间还没重置，说明后端主动断开了
        websock.close();     //如果onclose会执行reconnect，我们执行ws.close()就行了.如果直接执行reconnect 会触发onclose导致重连两次
      }, self.timeout)
    }, this.timeout)
  }
}


// WEBPACK FOOTER //
// ./src/components/notificationBar/webSockets.js